var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.881 17.014C16.4435 17.014 17.7085 15.7482 17.7085 14.1865V11.9365C16.6752 11.9365 15.8419 11.1032 15.8419 10.0707C15.8419 9.03738 16.6752 8.20488 17.7085 8.20488L17.7069 5.95238C17.7069 4.39071 16.4419 3.12488 14.8802 3.12488H5.1202C3.55854 3.12488 2.2927 4.39071 2.2927 5.95238L2.29187 8.27738C3.32437 8.27738 4.1577 9.03738 4.1577 10.0707C4.1577 11.1032 3.32437 11.9365 2.29187 11.9365V14.1865C2.29187 15.7482 3.55687 17.014 5.11854 17.014H14.881Z",
    stroke: "#202730",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99976 11.5452L11.4498 12.3077C11.5856 12.3786 11.7448 12.2636 11.7189 12.1127L11.4414 10.4969L12.6156 9.35441C12.7256 9.24691 12.6648 9.06107 12.5131 9.03857L10.8914 8.80274L10.1656 7.33274C10.0981 7.19524 9.90226 7.19524 9.83393 7.33274L9.1081 8.80274L7.48726 9.03857C7.3356 9.06107 7.27476 9.24691 7.38476 9.35441L8.5581 10.4969L8.2806 12.1127C8.25476 12.2636 8.41393 12.3786 8.54976 12.3077L9.99976 11.5452Z",
    stroke: "#202730",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/Tickets.ed419b7995dca3ecbd3572fa0ac97663.svg";
export { ForwardRef as ReactComponent };